module.exports = __webpack_public_path__ + "static/media/Avatars_Male-18.d010ce2c.png";